// Records the route the borrower navigated FROM during an in-app (SPA) navigation.
// The app is client-only (ssr: false), so this state survives SPA navigations but is
// wiped on a full page reload. On a reload (or a fresh load) the initial navigation
// has `to.path === from.path`, so we never record a previous route and consumers read
// an empty value — unlike history.state.back, which the browser keeps across reloads.
export default defineNuxtRouteMiddleware((to, from) => {
  if (to.path === from.path) {
    return
  }
  useState('previousRoutePath', () => '').value = from.path
})
